module.exports = __webpack_public_path__ + "img/flowPath-item1-on.a3374295.png";